<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Context Filters</h3>

    <div v-for="(filter, index) in resource.context_filters" :key="filter.label" class="halves">
      <div class="input-field">
        <input v-model="filter.label" type="text" placeholder="Label" />
        <span v-if="dig(errors.context_filters, index, 'label')" class="alert -inline -danger">
          {{ [...dig(errors.context_filters, index, 'label')].join(', ') }}
        </span>
      </div>
      
      <div class="input-field">
        <input v-model="filter.key" type="text" placeholder="Key" />
        <span v-if="dig(errors.context_filters, index, 'key')" class="alert -inline -danger">
          {{ [...dig(errors.context_filters, index, 'key')].join(', ') }}
        </span>
      </div>
      <a href="#" class="button -danger" @click.prevent="removeContextFilter(filter)">Remove filter</a>

      <hr />
    </div>

    <a href="#" class="button" @click.prevent="addContextFilter">Add filter</a>

    <hr />

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import dig from 'object-dig';
import _ from "underscore";

import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["context_filters"]
    };
  },

  methods: {
    dig,
    addContextFilter() {
      const dupe = _.clone(this.resource);
      dupe.context_filters.push({ label: "", key: "" });

      this.resource = dupe;
    },

    removeContextFilter(filter) {
      const dupe = _.clone(this.resource);
      dupe.context_filters = _.without(dupe.context_filters, filter);

      this.resource = dupe;
    }
  }
};
</script>
